<template>
  <div class="base-data-page">
    <!-- 内容卡片 -->
    <section class="bd-card">
      <el-tabs v-model="activeTab" @tab-click="onTabChange">
        <!-- ====== 大区/小区管理 ====== -->
        <el-tab-pane label="大区/小区管理" name="daqu">
          <div class="bd-toolbar">
            <el-button type="primary" size="small" @click="getDaquList">查询</el-button>
            <el-button size="small" @click="showAddDaqu">新增大区</el-button>
          </div>

          <div class="bd-table-wrap">
            <table class="bd-table" v-loading="daquLoading">
              <thead>
                <tr>
                  <th style="width:60px">序号</th>
                  <th>大区名称</th>
                  <th style="width:100px">小区数量</th>
                  <th style="width:80px">状态</th>
                  <th style="width:200px">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in daquList" :key="row.id">
                  <td class="td-muted">{{ idx + 1 }}</td>
                  <td>{{ row.daqu_name }}</td>
                  <td>{{ row.num || 0 }}</td>
                  <td>
                    <span class="bd-status" :class="row.is_delete ? 'danger' : 'success'">
                      {{ row.is_delete ? '已禁用' : '已启用' }}
                    </span>
                  </td>
                  <td>
                    <el-button type="text" size="mini" @click="showEditDaqu(row)">编辑</el-button>
                    <el-button type="text" size="mini" @click="toggleDaquStatus(row)">{{ row.is_delete ? '启用' : '禁用' }}</el-button>
                    <el-button type="text" size="mini" @click="showXiaoquList(row)">小区</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 空状态 -->
            <div v-if="!daquLoading && daquList.length === 0" class="bd-empty">
              <div class="bd-empty-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="10" y="14" width="28" height="20" rx="3" fill="#e2e8f0"/><rect x="16" y="20" width="16" height="3" rx="1.5" fill="#fff"/><rect x="16" y="26" width="10" height="3" rx="1.5" fill="#fff"/></svg>
              </div>
              <p class="bd-empty-title">暂无数据</p>
              <p class="bd-empty-desc">请尝试更换查询条件或新增记录</p>
            </div>
          </div>

          <!-- 小区列表 (展开) -->
          <div v-if="currentDaqu" class="bd-sub-section">
            <div class="bd-sub-header">
              <h3 class="bd-sub-title">小区管理 - {{ currentDaqu.daqu_name }}</h3>
              <el-button type="primary" size="small" @click="showAddXiaoqu">新增小区</el-button>
            </div>
            <div class="bd-table-wrap">
              <table class="bd-table" v-loading="xiaoquLoading">
                <thead>
                  <tr>
                    <th style="width:60px">序号</th>
                    <th>小区名称</th>
                    <th style="width:120px">经销商数量</th>
                    <th style="width:80px">状态</th>
                    <th style="width:150px">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in xiaoquList" :key="row.id">
                    <td class="td-muted">{{ idx + 1 }}</td>
                    <td>{{ row.xiaoqu_name }}</td>
                    <td>{{ row.num || 0 }}</td>
                    <td>
                      <span class="bd-status" :class="row.is_delete ? 'danger' : 'success'">
                        {{ row.is_delete ? '已禁用' : '已启用' }}
                      </span>
                    </td>
                    <td>
                      <el-button type="text" size="mini" @click="showEditXiaoqu(row)">编辑</el-button>
                      <el-button type="text" size="mini" @click="toggleXiaoquStatus(row)">{{ row.is_delete ? '启用' : '禁用' }}</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!xiaoquLoading && xiaoquList.length === 0" class="bd-empty">
                <p class="bd-empty-title">暂无小区</p>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- ====== 经销商管理 ====== -->
        <el-tab-pane label="经销商管理" name="dealer">
          <div class="bd-toolbar">
            <el-input v-model="dealerQuery.Keywords" placeholder="搜索经销商" clearable size="small" style="width:220px;margin-right:10px" @keyup.enter.native="getDealerList"></el-input>
            <el-button type="primary" size="small" @click="getDealerList">查询</el-button>
            <el-button type="warning" size="small" @click="exportDealerTemplate" style="margin-left:10px">导出模板</el-button>
            <el-upload
              :action="uploadDealerUrl"
              :headers="uploadHeaders"
              :data="{ project_id: projectId }"
              :before-upload="beforeDealerImport"
              :on-progress="onDealerImportProgress"
              :on-success="onDealerImportSuccess"
              :on-error="onImportError"
              :show-file-list="false"
              accept=".xlsx,.xls,.csv"
              style="display:inline-block;margin-left:10px"
            >
              <el-button type="success" size="small" :loading="dealerImporting">
                {{ dealerImporting ? '导入中...' : '导入经销商' }}
              </el-button>
            </el-upload>
          </div>

          <div class="bd-table-wrap">
            <div v-if="dealerImporting" class="import-progress-wrap">
              <div class="import-progress-header">
                <span class="title">正在导入经销商数据</span>
                <span class="percent">{{ dealerImportPercent }}%</span>
              </div>
              <el-progress
                :percentage="dealerImportPercent"
                :stroke-width="8"
                :show-text="false"
                color="#1476ff"
              ></el-progress>
            </div>
            <table class="bd-table" v-loading="dealerLoading">
              <thead>
                <tr>
                  <th style="width:50px">序号</th>
                  <th style="width:110px">经销商代码</th>
                  <th>经销商简称</th>
                  <th style="width:80px">省份</th>
                  <th style="width:80px">城市</th>
                  <th style="width:100px">销售大区</th>
                  <th style="width:100px">销售小区</th>
                  <th style="width:100px">状态</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in dealerList" :key="row.id">
                  <td class="td-muted">{{ (dealerQuery.Page - 1) * dealerQuery.Size + idx + 1 }}</td>
                  <td>{{ row.dealer_code }}</td>
                  <td>{{ row.dealer_shortname }}</td>
                  <td>{{ row.province }}</td>
                  <td>{{ row.city }}</td>
                  <td>{{ row.xiaoshou_daqu_name }}</td>
                  <td>{{ row.xiaoshou_xiaoqu_name }}</td>
                  <td>
                    <span class="bd-status" :class="row.status === 1 ? 'success' : 'danger'">
                      {{ row.status === 1 ? '启用' : '停用' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!dealerLoading && dealerList.length === 0" class="bd-empty">
              <div class="bd-empty-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="10" y="14" width="28" height="20" rx="3" fill="#e2e8f0"/><rect x="16" y="20" width="16" height="3" rx="1.5" fill="#fff"/><rect x="16" y="26" width="10" height="3" rx="1.5" fill="#fff"/></svg>
              </div>
              <p class="bd-empty-title">暂无数据</p>
              <p class="bd-empty-desc">请尝试更换查询条件或新增记录</p>
            </div>
          </div>
          <div v-if="dealerTotal > 0" class="bd-pagination">
            <el-pagination
              :current-page.sync="dealerQuery.Page"
              :page-size.sync="dealerQuery.Size"
              :total="dealerTotal"
              layout="total, prev, pager, next"
              @current-change="getDealerList"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <!-- 大区新增/编辑弹窗 -->
    <el-dialog :title="daquForm.Daqu_id ? '编辑大区' : '新增大区'" :visible.sync="daquDialogVisible" width="480px" append-to-body :modal-append-to-body="false" custom-class="sc-dialog">
      <el-form :model="daquForm" label-width="80px">
        <el-form-item label="大区名称">
          <el-input v-model="daquForm.Name" placeholder="请输入大区名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="daquDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveDaqu">确定</el-button>
      </span>
    </el-dialog>

    <!-- 小区新增/编辑弹窗 -->
    <el-dialog :title="xiaoquForm.Xiaoqu_id ? '编辑小区' : '新增小区'" :visible.sync="xiaoquDialogVisible" width="480px" append-to-body :modal-append-to-body="false" custom-class="sc-dialog">
      <el-form :model="xiaoquForm" label-width="80px">
        <el-form-item label="小区名称">
          <el-input v-model="xiaoquForm.Name" placeholder="请输入小区名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="xiaoquDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveXiaoqu">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'projectBaseData',
  data () {
    return {
      projectId: '',
      activeTab: 'daqu',
      businessTypes: [],
      // 大区
      daquQuery: { Page: 1, Size: 50, Business_id: '', Project_id: '' },
      daquList: [],
      daquLoading: false,
      daquDialogVisible: false,
      daquForm: { Daqu_id: '', Name: '', Business_id: 0, Project_id: '' },
      // 小区
      currentDaqu: null,
      xiaoquList: [],
      xiaoquLoading: false,
      xiaoquDialogVisible: false,
      xiaoquForm: { Xiaoqu_id: '', Name: '', Daqu_id: '', Business_id: 0, Project_id: '' },
      // 经销商
      dealerQuery: { Page: 1, Size: 20, Keywords: '', Project_id: '' },
      dealerList: [],
      dealerLoading: false,
      dealerTotal: 0,
      dealerImporting: false,
      dealerImportPercent: 0
    }
  },
  computed: {
    uploadDealerUrl () {
      return (process.env.VUE_APP_BASE_URL || '') + '/jkd/admin/loadDealers'
    },
    uploadHeaders () {
      return { Authorization: 'Bearer ' + (localStorage.getItem('ACCESS_TOKEN') || '') }
    }
  },
  methods: {
    getBusinessName (id) {
      const item = this.businessTypes.find(b => b.id === id)
      return item ? item.name : id
    },
    onTabChange () {
      if (this.activeTab === 'dealer') {
        this.getDealerList()
      } else {
        this.getDaquList()
      }
    },
    // ====== 大区 ======
    async getDaquList () {
      this.daquLoading = true
      this.currentDaqu = null
      this.daquQuery.Project_id = this.projectId
      const { data } = await this.axios.post('/bzmj/admin/area/daquList', this.daquQuery)
      this.daquList = data.data.list || []
      this.daquLoading = false
    },
    showAddDaqu () {
      this.daquForm = { Daqu_id: '', Name: '', Business_id: 0, Project_id: this.projectId }
      this.daquDialogVisible = true
    },
    showEditDaqu (row) {
      this.daquForm = { Daqu_id: String(row.id), Name: row.daqu_name, Business_id: row.business_type_id || 0, Project_id: this.projectId }
      this.daquDialogVisible = true
    },
    async saveDaqu () {
      this.daquForm.Project_id = this.projectId
      await this.axios.post('/bzmj/admin/area/addOrChangeDaqu', this.daquForm)
      this.$message.success('保存成功')
      this.daquDialogVisible = false
      this.getDaquList()
    },
    async toggleDaquStatus (row) {
      await this.axios.post('/bzmj/admin/area/changDaXiaoquStatus', { Id: row.id, Type: 'daqu' })
      this.$message.success('操作成功')
      this.getDaquList()
    },
    // ====== 小区 ======
    showXiaoquList (row) {
      this.currentDaqu = row
      this.getXiaoquList()
    },
    async getXiaoquList () {
      this.xiaoquLoading = true
      const bizId = this.currentDaqu.business_type_id || this.currentDaqu.Business_type_id || 2
      const { data } = await this.axios.post('/bzmj/admin/area/xiaoquList', {
        Daqu_id: this.currentDaqu.id,
        Business_id: bizId,
        Project_id: this.projectId,
        Page: 1,
        Size: 100
      })
      this.xiaoquList = (data.data && data.data.list) || (data.data && data.data.List) || []
      this.xiaoquLoading = false
    },
    showAddXiaoqu () {
      this.xiaoquForm = {
        Xiaoqu_id: '',
        Name: '',
        Daqu_id: String(this.currentDaqu.id),
        Business_id: this.currentDaqu.business_type_id || 0,
        Project_id: this.projectId
      }
      this.xiaoquDialogVisible = true
    },
    showEditXiaoqu (row) {
      this.xiaoquForm = {
        Xiaoqu_id: String(row.id),
        Name: row.xiaoqu_name,
        Daqu_id: String(this.currentDaqu.id),
        Business_id: this.currentDaqu.business_type_id || 0,
        Project_id: this.projectId
      }
      this.xiaoquDialogVisible = true
    },
    async saveXiaoqu () {
      this.xiaoquForm.Project_id = this.projectId
      await this.axios.post('/bzmj/admin/area/addOrChangeXiaoqu', this.xiaoquForm)
      this.$message.success('保存成功')
      this.xiaoquDialogVisible = false
      this.getXiaoquList()
    },
    async toggleXiaoquStatus (row) {
      await this.axios.post('/bzmj/admin/area/changDaXiaoquStatus', { Id: row.id, Type: 'xiaoqu' })
      this.$message.success('操作成功')
      this.getXiaoquList()
    },
    // ====== 经销商 ======
    async getDealerList () {
      this.dealerLoading = true
      this.dealerQuery.Project_id = this.projectId
      const { data } = await this.axios.post('/jkd/admin/dealers', this.dealerQuery)
      this.dealerList = data.data.list || []
      this.dealerTotal = data.data.pages ? data.data.pages.counts : 0
      this.dealerLoading = false
    },
    beforeDealerImport () {
      this.dealerImporting = true
      this.dealerImportPercent = 0
      return true
    },
    onDealerImportProgress (event) {
      const percent = event && typeof event.percent === 'number' ? Math.round(event.percent) : 0
      this.dealerImportPercent = Math.max(0, Math.min(99, percent))
    },
    onDealerImportSuccess () {
      this.dealerImportPercent = 100
      this.$message.success('导入成功，正在刷新数据')
      this.getDealerList()
      setTimeout(() => {
        this.dealerImporting = false
        this.dealerImportPercent = 0
      }, 400)
    },
    onImportError () {
      this.dealerImporting = false
      this.dealerImportPercent = 0
      this.$message.error('导入失败')
    },
    exportDealerTemplate () {
      this.axios.get('/jkd/admin/exportDealerTemplate',
        { project_id: this.projectId },
        { responseType: 'blob' }
      ).then(res => {
        const data = res.data || res
        const blob = data instanceof Blob ? data : new Blob([data])
        const filename = '厂家-经销商导入模板.xlsx'
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      }).catch(() => {
        this.$message.error('导出模板失败')
      })
    },
    // ====== 初始化 ======
    async getBusinessTypes () {
      try {
        const { data } = await this.axios.post('/bzmj/admin/dropDown/business')
        this.businessTypes = data.data || []
      } catch (e) {
        // survey 项目不分业务线，忽略
      }
    }
  },
  created () {
    this.projectId = this.$route.params.projectId || this.$route.query.project_id || ''
    this.getBusinessTypes()
    this.getDaquList()
  }
}
</script>

<style lang="scss" scoped>
.base-data-page {
  width: 100%;
}

/* 顶部操作栏 */
.bd-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 16px;
}

.bd-header-actions {
  display: flex;
  gap: 10px;
}

.bd-action-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  padding: 8px 20px !important;
  height: 36px !important;
  background: #4361ee !important;
  border-color: #4361ee !important;
  &:hover { background: #3a56d4 !important; border-color: #3a56d4 !important; }
}

/* 内容卡片 */
.bd-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px 28px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

/* 工具栏 */
.bd-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .el-button {
    border-radius: 8px !important;
    padding: 8px 20px !important;
    font-size: 13px !important;
    height: 34px !important;
    line-height: 1 !important;
  }

  .el-button--primary {
    background: #4361ee !important;
    border-color: #4361ee !important;
    &:hover { background: #3a56d4 !important; border-color: #3a56d4 !important; }
  }

  .el-button--default {
    background: #fff !important;
    border: 1px solid #dcdfe6 !important;
    color: #606266 !important;
    &:hover { color: #4361ee !important; border-color: #4361ee !important; }
  }
}

/* 表格 */
.bd-table-wrap {
  overflow-x: auto;
}

.import-progress-wrap {
  margin: 6px 0 12px;
  padding: 10px 14px 12px;
  background: #f9fbff;
  border: 1px solid #e6edf7;
  border-radius: 12px;
}

.import-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #64748b;
  font-size: 12px;
  margin-bottom: 6px;
}

.import-progress-header .title {
  color: #475569;
  font-weight: 600;
}

.import-progress-header .percent {
  color: #1476ff;
  font-weight: 600;
}

.import-progress-wrap ::v-deep .el-progress-bar__outer {
  background: #eaf1fb;
  border-radius: 999px;
}

.import-progress-wrap ::v-deep .el-progress-bar__inner {
  border-radius: 999px;
}

.bd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th {
    text-align: left;
    padding: 12px 16px;
    color: #94a3b8;
    font-weight: 500;
    font-size: 12px;
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f1f5f9;
    white-space: nowrap;
    background: #fafbfc;
  }

  td {
    padding: 14px 16px;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
    vertical-align: middle;
  }

  tbody tr:hover td {
    background: #f8fafc;
  }
}

.td-muted {
  color: #94a3b8 !important;
}

/* 状态标签 */
.bd-status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;

  &.success {
    background: #f0fdf4;
    color: #16a34a;
  }
  &.danger {
    background: #fef2f2;
    color: #dc2626;
  }
}

/* 空状态 */
.bd-empty {
  text-align: center;
  padding: 60px 0 80px;
}

.bd-empty-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 20px;
  background: #eef2ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bd-empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  margin: 0 0 6px;
}

.bd-empty-desc {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* 分页 */
.bd-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

/* 小区子区域 */
.bd-sub-section {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}

.bd-sub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .el-button {
    border-radius: 8px !important;
    padding: 8px 20px !important;
    font-size: 13px !important;
    height: 34px !important;
    line-height: 1 !important;
  }

  .el-button--primary {
    background: #4361ee !important;
    border-color: #4361ee !important;
    &:hover { background: #3a56d4 !important; border-color: #3a56d4 !important; }
  }
}

.bd-sub-title {
  font-size: 15px;
  font-weight: 700;
  color: #1476ff;
  margin: 0;
}

/* el-tabs 样式覆盖 */
::v-deep .el-tabs__nav-wrap::after {
  height: 1px !important;
  background: #f1f5f9 !important;
}

::v-deep .el-tabs__item {
  font-size: 14px !important;
  color: #64748b !important;
  font-weight: 500 !important;
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;

  &.is-active {
    color: #1476ff !important;
    font-weight: 600 !important;
  }
}

::v-deep .el-tabs__active-bar {
  background-color: #1476ff !important;
  height: 3px !important;
  border-radius: 2px !important;
}
</style>

<style lang="scss">
/* sc-dialog 弹窗风格（与 Settings.vue 一致） */
.sc-dialog.el-dialog {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    padding: 28px 32px 20px !important;
    margin-right: 0 !important;
    border-bottom: none !important;
    background: #fff !important;

    .el-dialog__title {
      font-size: 18px !important;
      font-weight: 700 !important;
      color: #1a1a1a !important;
    }

    .el-dialog__headerbtn {
      top: 28px !important;
      right: 28px !important;
      font-size: 20px !important;

      .el-dialog__close {
        color: #c0c4cc !important;
        &:hover { color: #909399 !important; }
      }
    }
  }

  .el-dialog__body {
    padding: 4px 32px 28px !important;
    background: #fff !important;
  }

  .el-dialog__footer {
    padding: 20px 32px 28px !important;
    border-top: 1px solid #f0f0f0 !important;
    background: #fff !important;
  }

  .el-form-item__label {
    font-size: 14px !important;
    color: #303133 !important;
    font-weight: 400 !important;
  }

  .el-input__inner {
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 6px !important;
    border-color: #e4e7ed !important;
    font-size: 14px !important;

    &:focus { border-color: #3b82f6 !important; }
  }

  .el-button {
    border-radius: 8px !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    min-width: 80px !important;
    height: 40px !important;
    padding: 0 24px !important;
  }

  .el-button--primary {
    background: #3b82f6 !important;
    border-color: #3b82f6 !important;
    &:hover { background: #2563eb !important; border-color: #2563eb !important; }
  }

  .el-button--default {
    background: #fff !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    &:hover { color: #3b82f6 !important; border-color: #3b82f6 !important; background: #f0f7ff !important; }
  }
}
</style>
